import {TextField} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {bgColorRequester, bgColorSpender} from '../../_helpers';

/**
 * Textfield limited to N max characters. Display a tooltip when limit is reached.
 *
 * @param {LimitedLengthTextfield.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function LimitedLengthTextfield({value, disabled, onChange, maxLength, mandatoryForSpender, mandatoryForRequester, highlightMandatoryFieldForRequester, highlightMandatoryFieldForSpender, variant, ...rest}) {
    const [openTooltip, setOpenTooltip] = useState(false);
    const [internalValue, setInternalValue] = useState(value);

    // We have to update internalValue every time material description changes to keep it updated.
    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    const handleChange = (event) => {
        const value = event.target.value;
        if (value.length > maxLength) {
            setInternalValue(value.substr(0, maxLength));
            setOpenTooltip(true);
        } else {
            setInternalValue(value);
            setOpenTooltip(false);
        }
    };
    const handleBlur = () => {
        setOpenTooltip(false);
        onChange(internalValue);
    };

    return <Tooltip
        title={`Too many characters. Only ${maxLength} characters are allowed.`}
        open={openTooltip}
        placement={'top'}
        arrow >
        <TextField
            sx={{
                backgroundColor: mandatoryForSpender && highlightMandatoryFieldForSpender ?
                    bgColorSpender :
                    mandatoryForRequester && highlightMandatoryFieldForRequester ?
                        bgColorRequester :
                        null,
            }}
            disabled={disabled}
            fullWidth
            value={internalValue}
            onChange={handleChange}
            onBlur={handleBlur}
            variant={variant}
            size={'small'}
            {...rest}
        />
    </Tooltip>;
}

LimitedLengthTextfield.propTypes = {
    value: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    maxLength: PropTypes.number,
    variant: PropTypes.string,
    mandatoryForSpender: PropTypes.bool,
    mandatoryForRequester: PropTypes.bool,
    highlightMandatoryFieldForRequester: PropTypes.bool,
    highlightMandatoryFieldForSpender: PropTypes.bool,
};
